import { connect } from "react-redux";

import Button from "@components/Button";
import SelectedLockerMarkerIcon from "@components/Icons/Lockers/SelectedLockerMarkerIcon";
import { PRODUCT_PAGE_MODAL_LOCKERS_MAP_ID } from "@components/Lockers/_lib/constants";
import LockerCardRoutingAction from "@components/Lockers/LockerCard/LockerCardRoutingAction";
import { addModal } from "@store/app/actions";
import LockerCardName from "@components/Lockers/LockerCard/LockerCardName";
import LockerCardAddress from "@components/Lockers/LockerCard/LockerCardAddress";
import LockerCardInactiveTag from "@components/Lockers/LockerCard/LockerCardInactiveTag";

const UserWithLocker = ({ selectedLocker, addModal }) => {
  const handleAddLockerModal = (event) => {
    event.preventDefault();
    addModal(PRODUCT_PAGE_MODAL_LOCKERS_MAP_ID);
  };

  return (
    <div className="flex flex-col lg:flex-row items-start lg:items-center lg:justify-between gap-[8px]">
      <div className="text-[14px] space-y-[8px] leading-tight">
        <div>
          <div className="flex flex-wrap items-center gap-[4px]">
            <SelectedLockerMarkerIcon color="#2CAAE1" />

            <LockerCardName locker={selectedLocker} />

            <LockerCardInactiveTag locker={selectedLocker} />
          </div>

          <LockerCardAddress locker={selectedLocker} />
        </div>

        <LockerCardRoutingAction locker={selectedLocker} />
      </div>

      {/* Changing the pickup point is the way out, so the button always stays enabled */}
      <Button
        title="Schimba"
        size="small"
        variant="third"
        isOrderAgain
        onClick={handleAddLockerModal}
      />
    </div>
  );
};

export default connect(null, { addModal })(UserWithLocker);
